<style lang="less">
    .fill .art_text_con{
        width:100%;
        height:auto;
        background: #78D3FF;
        border:2px solid #1D2088;
        box-shadow:0px .08rem .02rem 0px rgba(0, 0, 0, 0.3);
        border-radius: .1rem;
        padding:.6rem .2rem .2rem;
        z-index: 9;
        >img{
            width:100%;
            height:auto;
            display: block;
        }
        .art_inner{
            width:100%;
            background:#FFFDE4;
            padding:.2rem .4rem 0;
            >div{
                width:100%;
                height:100%;
                overflow-y: auto;
                >img{
                    width:100%;
                    height:auto;
                    display: block;
                    margin-bottom: .4rem;
                }
            }
        }
    }
    .fill .play_trast_con{
        width:100%;
        height:auto;
        min-height: 4.5rem;
        padding:0.4rem 0.8rem .8rem;
        background:url("../assets/images/blackboard-phone.png") no-repeat;
        background-size:100% 100%;
        p{
            width:100%;
            padding:0 .1rem;
            line-height: 1.4;
            color:#fff;
            font-size: .32rem;
        }
        p.started{
            padding: .5rem .1rem .5rem;
        }
        p.right{
            padding: 1rem .1rem .3rem;
            font-size: .8rem;
            text-align: center;
        }
        p.wrong{
            padding: .5rem .1rem .3rem;
            font-size: .8rem;
            text-align: center;
        }
        .btnHover{
            margin:.3rem auto 0;
        }
    }
    .fill .tra_bottom{
        width:100%;
        margin:.6rem auto 0;
        padding-bottom: .3rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        >div{
            width:1.4rem;
            height:auto;
            position: relative;
            img{
                width:100%;
                height:auto;
                display: block;
            }
            span{
                font-size: .3rem;
                color:#333;
                transform: translateX(-50%);
                position: absolute;
                left: 50%;
                bottom:.3rem;
                z-index: 11;
                white-space: nowrap;
            }
            span.active{
                bottom:.57rem;
            }
        }
    }
</style>
<template>
    <div class="fill" @touchmove.prevent>
        <div class="pd">
            <div class="art_text_con"><!-- 蓝底 padding -->
                <img src="../assets/images/up-article-phone.png" alt="">
                <div class="art_inner"><!-- 黄底 padding -->
                    <div>
                        <div class="play_trast_con">
                            <p v-if="isStart && status=='wait'" class="started" v-html="gameData.question"></p>
                            <p v-else-if="!isStart && status=='wait'">下面四位同學裡，有一位手上的文字是可以填補魔法句子的空白處，你需要选择正确的答案到句子中空白處即可完成遊戲！</p>
                            <p class="wrong" v-if="status=='wrong'">答錯了</p>
                            <p class="right" v-else-if="status=='right'">答對了！</p>
                            <div class="btnHover" v-if="status=='wait'" v-show="!isStart || (isStart&&choice_idx!=='')" @click="start">確認</div>
                            <div class="btnHover" v-else-if="status=='wrong'" @click="again">再玩一次</div>
                        </div>
                    </div>
                    <div class="tra_bottom">
                        <div v-for="(item,index) in gameData.opts" :key="index" @click="choiceAnswer(item,index)">
                            <img :src="choice_idx===index?'../../static/img/game-boy-select-pc.png':require('../assets/images/game-boy-pc.png')" alt="">
                            <span :class="{'active':choice_idx===index}" v-show="isStart">{{item.text}}</span>
                        </div>
                    </div>
                </div>
                <img src="../assets/images/down-article-phone.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        gameData:{
            type:Object,
            default:{},
        },
        game_id:{
            type:String,
            default:'1',
        },
        date:{
            type:String,
            default:'',
        },
        push_id:{
            type:String,
            default:'',
        }
    },
    data(){
        return {
            status:'wait',
            isStart:false,
            choice_idx:'',
        }
    },
    mounted(){
        console.log('填一填',this.game_id);
        this.preImg();
    },
    methods:{
        choiceAnswer(item,index){
            this.choice_idx = index;
            document.querySelector('#word_set').innerHTML='（ '+ item.text +' ）';
        },
        preImg(){
            let img = new Image();;
            img.src = require('../../static/img/game-boy-select-pc.png');
        },
        again(){
            this.status='wait';
            this.choice_idx='';
        },
        start(){
            let vm = this;
            if(this.isStart){
                if(this.choice_idx===''){
                    return;
                }
                this.$http.get(this.baseUrl+'/Game/fillPush/GaID/'+this.game_id+ '/SrtSet/'+this.gameData.opts[this.choice_idx].id+"/SrtTime/"+ 5 + '/pushdate/'+ this.date +"/sn/"+ Math.random()).then(res=>{
                    console.log(res)
                    if(res.data == 'pass'){
                        vm.status = 'right';
                        setTimeout(()=>{
                            vm.$emit('next');
                        },3000)
                    }else{
                        vm.status = 'wrong';
                    }
                })
            }else{
                this.isStart=true;
                this.choice_idx='';
            }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/game-fill.vue